export const PROFILE = {
  name: "Saanvi Y Gupte",
  firstName: "Saanvi",
  lastName: "Gupte",
  title: "Fashion Communication Student",
  tagline: "Creative direction · visual storytelling · luxury branding",
  bio: "Creative and detail oriented Fashion Communication student with a strong interest in luxury branding, visual storytelling and creative direction. Passionate about combining fashion, marketing and design to create meaningful brand experiences. Experienced in styling, fashion events, exhibition design and digital content creation, with a growing interest in the global luxury and fashion industry. Known for adaptability, creativity and a keen eye for aesthetics and consumer engagement.",
  location: "India",
  phone: "+91 9586055511",
  phoneRaw: "919586055511",
  email: "saanviyg@gmail.com",
  linkedin: "https://www.linkedin.com/in/saanvi-gupte-a56a2a359",
  instagram: "https://www.instagram.com/saanvixgupte",
  instagramHandle: "@saanvixgupte",
  whatsapp: "https://wa.me/919586055511",
  about_image: "https://customer-assets.emergentagent.com/job_luxury-3d-style/artifacts/zljfq911_IMG_4178.jpeg",
};

// All images uploaded by Saanvi — runway, illustrations, silk scarf collection, exhibition curation
export const PORTFOLIO = [
  {
    id: "p1",
    title: "Runway · Couture Lineup",
    category: "Editorial",
    year: "2024",
    role: "Show Direction · Styling",
    description: "Closing walk of a multi-designer showcase — feathers, monochrome tailoring and theatrical staging.",
    image: "https://customer-assets.emergentagent.com/job_luxury-3d-style/artifacts/431log6l_DSC_0891.jpeg",
    span: "lg:col-span-7 lg:row-span-2",
  },
  {
    id: "p2",
    title: "Furred Tailoring · Concept",
    category: "Styling",
    year: "2025",
    role: "Illustration · Concept",
    description: "A minimal couture concept — relaxed jacket meets sculptural fur trousers.",
    image: "https://customer-assets.emergentagent.com/job_luxury-3d-style/artifacts/v1qi164m_IMG_1398.jpeg",
    span: "lg:col-span-5",
  },
  {
    id: "p3",
    title: "Liquid Chrome Menswear",
    category: "Styling",
    year: "2025",
    role: "Illustration · Direction",
    description: "Chrome second-skin top against a soft tailored trouser — exploring metallic surfaces in menswear.",
    image: "https://customer-assets.emergentagent.com/job_luxury-3d-style/artifacts/0zq0220q_PHOTO-2025-02-12-10-53-50.jpeg",
    span: "lg:col-span-5",
  },
  {
    id: "p4",
    title: "Inferno Gown · Editorial",
    category: "Editorial",
    year: "2025",
    role: "Creative Direction",
    description: "A sculptural cinnabar gown with an oversized bow — a study in proportion and presence.",
    image: "https://customer-assets.emergentagent.com/job_luxury-3d-style/artifacts/8ilxb9hd_IMG_1439.jpeg",
    span: "lg:col-span-7",
  },
  {
    id: "p5",
    title: "Bloom Dots · Printed Silk",
    category: "Styling",
    year: "2025",
    role: "Print Design · Styling",
    description: "A hand-printed silk scarf — saturated watercolor dots floating on a soft cream ground.",
    image: "https://customer-assets.emergentagent.com/job_luxury-3d-style/artifacts/pbfxrqyk_53D7E8FB-C114-4876-B208-D7FF4990E843.jpeg",
    span: "lg:col-span-4",
  },
  {
    id: "p6",
    title: "Crimson Atmosphere · Silk Series",
    category: "Editorial",
    year: "2025",
    role: "Print Design · Concept",
    description: "Magenta and bruised-burgundy clouds bleed across silk — a moody, painterly composition.",
    image: "https://customer-assets.emergentagent.com/job_luxury-3d-style/artifacts/60dgynk6_9FD83664-4DE5-48FB-8B96-4936C1C6EDEE.png",
    span: "lg:col-span-4",
  },
  {
    id: "p7",
    title: "Botanica Noir · Silk Scarf",
    category: "Styling",
    year: "2025",
    role: "Print Design",
    description: "A ghost-print of wild botanicals on dyed black silk — restraint and shadow as design language.",
    image: "https://customer-assets.emergentagent.com/job_luxury-3d-style/artifacts/4f49i420_53D7E8FB-C114-4876-B208-D7FF4990E843.jpeg",
    span: "lg:col-span-4",
  },
  {
    id: "p8",
    title: "Atelier Booth · Exhibition Curation",
    category: "Editorial",
    year: "2025",
    role: "Exhibition Design · Curation",
    description: "A live exhibition booth showcasing the silk-scarf capsule — moodboards, hanging textiles and immersive staging.",
    image: "https://customer-assets.emergentagent.com/job_luxury-3d-style/artifacts/fcu1d2ef_FullSizeRender.jpeg",
    span: "lg:col-span-6",
  },
  {
    id: "p9",
    title: "Gallery · Caravaggio Inspired",
    category: "Editorial",
    year: "2025",
    role: "Exhibition Design · Art Direction",
    description: "A gallery installation pairing Caravaggio reference plates with draped textile works and damask walls.",
    image: "https://customer-assets.emergentagent.com/job_luxury-3d-style/artifacts/t6bb67vv_FullSizeRender.jpeg",
    span: "lg:col-span-6",
  },
];

export const CATEGORIES = ["All", "Editorial", "Styling"];

export const SERVICES = [
  { n: "01", title: "Creative Direction", desc: "Guiding the visual language and narrative for fashion brands, shoots and runway moments.", image: "https://customer-assets.emergentagent.com/job_luxury-3d-style/artifacts/8ilxb9hd_IMG_1439.jpeg" },
  { n: "02", title: "Visual Storytelling", desc: "Crafting compelling narratives through editorial imagery, copy and considered design.", image: "https://customer-assets.emergentagent.com/job_luxury-3d-style/artifacts/60dgynk6_9FD83664-4DE5-48FB-8B96-4936C1C6EDEE.png" },
  { n: "03", title: "Fashion Styling", desc: "Curating looks for editorials and exclusive events with a couture sensibility.", image: "https://customer-assets.emergentagent.com/job_luxury-3d-style/artifacts/v1qi164m_IMG_1398.jpeg" },
  { n: "04", title: "Exhibition Design", desc: "Designing spatial experiences and installations that translate brand essence into atmosphere.", image: "https://customer-assets.emergentagent.com/job_luxury-3d-style/artifacts/t6bb67vv_FullSizeRender.jpeg" },
  { n: "05", title: "Digital Content", desc: "Producing high-end digital assets tailored to the luxury market — short film, stills, motion.", image: "https://customer-assets.emergentagent.com/job_luxury-3d-style/artifacts/431log6l_DSC_0891.jpeg" },
  { n: "06", title: "Luxury Branding", desc: "Developing cohesive brand identities that exude exclusivity, restraint and intent.", image: "https://customer-assets.emergentagent.com/job_luxury-3d-style/artifacts/pbfxrqyk_53D7E8FB-C114-4876-B208-D7FF4990E843.jpeg" },
];

export const SKILLS = [
  "Adobe Photoshop", "Adobe Illustrator", "Canva", "Fashion Styling",
  "Visual Merchandising", "Digital Illustration", "Photography & Editing",
  "Fashion Communication", "Brand Storytelling", "Social Media Marketing",
];

export const STATS = [
  { n: 14, suffix: "+", label: "Projects Directed" },
  { n: 3, suffix: "+", label: "Years of Craft" },
  { n: 100, suffix: "%", label: "Detail Obsession" },
];

// All process tiles use Saanvi's own work
export const PROCESS_GALLERY = [
  { url: "https://customer-assets.emergentagent.com/job_luxury-3d-style/artifacts/v1qi164m_IMG_1398.jpeg", label: "Sketch" },
  { url: "https://customer-assets.emergentagent.com/job_luxury-3d-style/artifacts/pbfxrqyk_53D7E8FB-C114-4876-B208-D7FF4990E843.jpeg", label: "Print" },
  { url: "https://customer-assets.emergentagent.com/job_luxury-3d-style/artifacts/fcu1d2ef_FullSizeRender.jpeg", label: "Exhibit" },
  { url: "https://customer-assets.emergentagent.com/job_luxury-3d-style/artifacts/431log6l_DSC_0891.jpeg", label: "Showcase" },
];

export const BLOG_POSTS = [
  {
    id: "wardrobe-essentials",
    title: "Wardrobe Essentials",
    subtitle: "Building a Timeless and Versatile Collection",
    author: "Saanvi Gupte",
    date: "2025",
    readTime: "4 min read",
    cover: "https://customer-assets.emergentagent.com/job_luxury-3d-style/artifacts/8ilxb9hd_IMG_1439.jpeg",
    excerpt: "Putting together a classic and adaptable outfit doesn't have to be difficult. You can create a collection that fits every occasion and stays fashionable for years by concentrating on a small number of essential pieces.",
    sections: [
      {
        n: "01",
        title: "Classic White Shirt",
        body: "Its adaptability requires a white shirt. A well-fitting, premium cotton shirt is perfect for both formal and informal occasions, and it can be dressed up or down.",
      },
      {
        n: "02",
        title: "Tailored Blazer",
        body: "A blazer in a neutral color, such as gray, navy, or black, elevates any ensemble. When worn with dress pants or jeans, it's ideal for formal gatherings as well as smart-casual settings.",
      },
      {
        n: "03",
        title: "Dark Denim Jeans",
        body: "Dark denim provides a sophisticated yet laid-back style. Select a classic fit that goes well with different tops and accentuates the contours of your body.",
      },
      {
        n: "04",
        title: "Timeless Accessory",
        body: "Accessories are a woman's best friend. Wearing accessories gives you an extra stylish look and feel, and shows that you put more effort into your outfit. Invest in timeless accessories to go with your outfit, such as a leather belt, a basic watch, golden hoops and a multipurpose purse.",
      },
      {
        n: "05",
        title: "Versatile Knit Sweater",
        body: "A sweater with a neutral fabric is perfect for layering. Seek for high-quality material and a timeless style that complements both formal and informal ensembles.",
      },
    ],
    conclusion: "You'll have an effortlessly stylish and useful base with these staples, making dressing for any occasion a breeze.",
  },
];
